<template src="./index.html">
</template>
<script>
export default {
  name: '',
  components: {
  }, 
  data: function() {
    return {
    };
  },
  props:{
	  text:{
		  type:String,
		  default:"",
		  rightboxwidth:0
	  },
	  textarea:{
		  type:String,
		  default:"",
	  }
  },
  created() {
  },
  mounted() {
	 
  },
  methods: {
	  forback(){
		  document.onkeydown = ''//销毁键盘事件
		  this.$emit("forback",true)
	  }
  }
};
</script>


<style scoped lang="less">
@import url('./index.less');
</style>
